module.exports = __webpack_public_path__ + "img/_dsc8147.1b0fb4d7.jpg";